import React, { useEffect, useState } from 'react'
import style from './WarningButton.module.css'

const Button = ({text, disabled, onClick}) => {
    
    const [buttonStyle, setButtonStyle] = useState(style.button);

    useEffect(() => {
        if (disabled) {
            setButtonStyle(style.buttonDisabled)
        } else {
            setButtonStyle(style.button)
        }
    },[disabled]) 

    return (
        <div className={style.container} onClick={onClick}>
            <p className={buttonStyle}>{text}</p>
        </div>
    )
}

export default Button